import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function ChevronRight({ width, height, color }: { height: number; width: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={width} height={height} viewBox="0 0 8 12">
      <G id="CC" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="button-/-text" transform="translate(-225.000000, -12.000000)" fill={finalColor} fillRule="nonzero">
          <G id="right-arrow" transform="translate(225.000000, 12.000000)">
            <Path
              d="M6.85848083,5.5317599 L1.51832912,0.191705758 C1.39481793,0.0680970073 1.22994122,0 1.05413777,0 C0.878334322,0 0.713457614,0.0680970073 0.589946423,0.191705758 L0.196681328,0.584873294 C-0.0592190307,0.841066333 -0.0592190307,1.25745319 0.196681328,1.51325599 L4.68093755,5.99751222 L0.191705758,10.486744 C0.0681945675,10.6103528 0,10.7751319 0,10.9508378 C0,11.1267388 0.0681945675,11.291518 0.191705758,11.4152243 L0.584970854,11.8082942 C0.708579605,11.931903 0.873358753,12 1.0491622,12 C1.22496565,12 1.38984236,11.931903 1.51335355,11.8082942 L6.85848083,6.46336209 C6.9822847,6.33936309 7.05028414,6.17380347 7.04989557,5.9978049 C7.05028414,5.82112341 6.9822847,5.65566134 6.85848083,5.5317599 Z"
              id="Path"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
export default ChevronRight;
